import axios from "axios";
import { API } from "@/lib/api";

let cfg;
const load = () => {
  cfg = cfg || axios.get(`${API}/site-config`).then((r) => r.data?.conversions || {}).catch(() => ({}));
  return cfg;
};

// Fires a Google Ads conversion once the admin has pasted its label (Admin -> Tracking). No label = no-op.
export const trackConversion = async (kind, opts = {}) => {
  const sendTo = (await load())[kind];
  if (!sendTo || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: sendTo, ...opts });
};
